import { render, staticRenderFns } from "./InputTaxRate.vue?vue&type=template&id=2c7551a6&scoped=true&"
import script from "./InputTaxRate.vue?vue&type=script&lang=js&"
export * from "./InputTaxRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7551a6",
  null
  
)

export default component.exports